import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useTabBarReducer } from '../../../hooks/tabMenuReducer/tabMenuReducer';
import { useEntryStore } from '../../../store/entry/entryStore';
import Header from '../../Header/Header';
import TabMenu from '../../TabMenu/TabMenu';
import PrizePool from '../../PrizePool/PrizePool';
import Carousel, { CarouselItem } from '../../Carousel/Carousel';
import { eventNumbers, getEventWrappers, getMySelectionScreen, getTargetTab } from './SelectionScreen.functions';
import { TabText } from 'components/TabMenuItem/TabMenuItem';
import { useRetrieveByEventNumber } from '../../../store/event/eventActions';
import './SelectionScreen.scss';
import { useConfigStore } from '../../../store/options/optionsStore';

const SelectionScreen = () => {
  const gameTitle = useConfigStore((s) => s.gameTitle);
  const { t } = useTranslation();
  const entry = useEntryStore((s) => s.entry);
  const [{ items, current, prev }, { setTab, setEntered }] = useTabBarReducer(eventNumbers[0], [
    ...eventNumbers,
    'my-selections',
  ]);
  const [updatedEvent, setUpdatedEvent] = useState<number | undefined>();
  const currentEvent = useRetrieveByEventNumber(typeof current === 'number' ? current : undefined);
  const setSelectedPick = useEntryStore((s) => s.setPick);
  //if loading entry, set tab to my-selections
  useEffect(() => {
    if (!entry?.picks) return;
    if (entry.picks.some((p) => !p.selectionCode)) return;
    setEntered();
  }, [entry?.picks, setEntered]);

  const mySelections = getMySelectionScreen({
    setUpdatedEvent,
    setTab,
    updatedEvent,
    t,
  });

  const eventWrappers = getEventWrappers({
    eventNumbers,
    setTab,
    // if the previous tab was my-selections then we have clicked the update button,
    // since you only see the my-selections page once all selections have been made
    updatedEvent: prev === 'my-selections',
    setUpdatedEvent,
    items,
  });

  const handleTabClick = (targetTab: TabText) => {
    const nextTab = getTargetTab({ current, eventNumbers, items, targetTab, currentEvent });
    if (!nextTab) return;
    if (!currentEvent?.eventActive && typeof current === 'number') {
      if (currentEvent?.eventId === undefined) return;
      setSelectedPick({
        eventNumber: current,
        selectionCode: '1',
        eventId: currentEvent?.eventId,
        marketId: currentEvent?.markets[0].marketId,
      });
    }
    setTab({ item: nextTab.item, selectionMade: nextTab.currentTabSelectionMade });
  };

  const handleSetCurrent = (item: CarouselItem) => {
    const nextTab = getTargetTab({ current, eventNumbers, items, targetTab: item.id, currentEvent });
    if (!nextTab) return;

    setTab({ item: nextTab.item, selectionMade: nextTab.currentTabSelectionMade });
  };

  return (
    <>
      <Header showPrize={false} />
      <div className={'selection-screen'}>
        {gameTitle && <div className={'selection-screen__game-title'}>{gameTitle}</div>}
        <TabMenu items={items} onClick={handleTabClick} />
        <div className={'selection-screen__wrapper'}>
          <Carousel items={[...eventWrappers, mySelections]} current={current} setCurrent={handleSetCurrent} />
          <PrizePool />
        </div>
      </div>
    </>
  );
};
export default SelectionScreen;
